<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-1767.5 -329)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1767.5 329)" />
			<path
				d="M33.391,8.234,30.747,5.59,18.86,17.478,21.5,20.121Zm7.95-2.644L21.5,25.428l-7.838-7.819-2.644,2.644L21.5,30.734,44,8.234ZM.41,20.253,10.891,30.734l2.644-2.644L3.072,17.609Z"
				transform="translate(1767.859 333.891)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-done-all',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
path.a {
	fill: none;
}
</style>

<docs>
	IconDoneAll

	```js
	<b-icon-done-all />
	```
</docs>
